import { createSelector } from 'reselect';

import { ApplicationRootState } from 'store/types';
import { DeviceId } from 'types/models/device';

const selectDevices = (state: ApplicationRootState) => state.devices;

const selectDevicesAsArray = createSelector(selectDevices, (devices) =>
  Object.values(devices)
);

const makeSelectDevice = (deviceId: DeviceId) =>
  createSelector(selectDevices, (devices) => devices[deviceId]);

const makeSelectDevicesBySiteId = (siteId: number) =>
  createSelector(selectDevicesAsArray, (devices) => {
    return devices.filter((device) => device.siteId === siteId);
  });

export {
  selectDevices,
  selectDevicesAsArray,
  makeSelectDevice,
  makeSelectDevicesBySiteId
};
